module.exports = __webpack_public_path__ + "static/media/local-community-occasion-grid-4.baba7499.jpg";